enum MyWebsiteV3MastheadAlignmentVertical {
    Centre,
    Top,
    Bottom
}

export default MyWebsiteV3MastheadAlignmentVertical
